<template>
  <auth>
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div style="padding: 60px; margin-bottom: 3rem;">
          <div class="alert alert-success">
            <p style="margin: 30px;text-align: center">
              An email has been sent to {{ $auth.getVerifyUser()
              }}. Please
              click on the link in your email to continue.
            </p>
            <div
              v-if="can_request_resend"
              style="text-align: center"
            >
              <a
                href="#"
                class="btn btn-primary"
                @click.prevent="resend"
              >Resend verification
                email.</a>
            </div>
            <div
              v-if="! can_request_resend"
              style="text-align: center"
            >
              <p>Wait <span>{{ timerCount }}</span> seconds and retry if no email was received</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </auth>
</template>

<script>
    import Auth from "@/components/Auth.vue";

    export default {
        components: {
            Auth
        },
        data() {
            return {
                can_request_resend: false,
                timerCount: 60
            }
        },
        watch: {
            timerCount: {
                handler(value) {

                    if (value > 0) {
                        setTimeout(() => {
                            this.timerCount--;
                        }, 1000);
                    } else {
                        this.can_request_resend = true;
                    }

                },
                immediate: true // This ensures the watcher is triggered upon creation
            }

        },
        methods: {
            resend() {
                let data = {
                    email: this.$auth.getVerifyUser()
                };
                this.can_request_resend = false;
                this.timerCount = 60;
                this.$axios.post('/api/v1/resend-email', data).then(() => {
                    this.$toastr.s("Email sent");
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
.alert p{
  color: #fff;
}
</style>